export enum ManagedPostStatus {
  Scheduled = 'SCHEDULED',
  Processing = 'PROCESSING',
  Error = 'ERROR',
  Published = 'PUBLISHED',
  Deleted = 'DELETED',
  Rejected = 'REJECTED',
  Draft = 'DRAFT',
}
